import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from '@app/core/services/logging.service';

@Component({
  selector: 'app-dynamic-dialog',
  templateUrl: './dynamic-dialog.component.html',
  styleUrls: ['./dynamic-dialog.component.scss']
})
export class DynamicDialogComponent {
  constructor(
    private ls: LoggingService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      cancelText: string;
      confirmText: string;
      message: string;
      title: string;
      iconSrc: string;
      spinner: string;
      id: string;
      disableClose: string;
    },
    private mdDialogRef: MatDialogRef<DynamicDialogComponent>
  ) {}
  public cancel(): void {
    this.close(false);
    this.ls.sendInfoLevelMessage('Dynamic Dialog Cancel');
  }
  public close(value): void {
    this.mdDialogRef.close(value);
    this.ls.sendInfoLevelMessage('Dynamic Dialog Close');
  }
  public confirm(): void {
    this.close(true);
    this.ls.sendInfoLevelMessage('Dynamic Dialog Confirm');
  }
  @HostListener('keydown.esc')
  public onEsc(): void {
    this.close(false);
  }
}
